var _defs, _rect, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLoyaltyCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 48,
    viewBox: "0 0 71 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4541",
    x: 0,
    y: 0,
    width: 71,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4978",
    "data-name": "Rectangle 4978",
    d: "M0,0H34a0,0,0,0,1,0,0V37a0,0,0,0,1,0,0H2a2,2,0,0,1-2-2V0A0,0,0,0,1,0,0Z",
    transform: "translate(210.671 414.52)",
    fill: "#ffb5b5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12277",
    "data-name": "Group 12277",
    transform: "translate(-144.5 -466.5)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12274",
    "data-name": "Group 12274"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4974",
    "data-name": "Rectangle 4974",
    width: 67,
    height: 45,
    transform: "translate(147 468)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11907",
    "data-name": "Group 11907",
    transform: "translate(-1105 -4273.563)",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1249.5, 4740.06)",
    filter: "url(#Rectangle_4541)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4541-2",
    "data-name": "Rectangle 4541",
    width: 62,
    height: 39,
    rx: 2,
    transform: "translate(4.5 3.5)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_110",
    "data-name": "Mask Group 110",
    transform: "translate(1043.329 4331.043)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13113",
    "data-name": "Group 13113",
    transform: "translate(179.623 416.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13112",
    "data-name": "Group 13112",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_979",
    "data-name": "Ellipse 979",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(0.047 -0.189)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_980",
    "data-name": "Ellipse 980",
    cx: 27.413,
    cy: 27.413,
    r: 27.413,
    transform: "translate(4.165 3.896)",
    fill: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_981",
    "data-name": "Ellipse 981",
    cx: 23.655,
    cy: 23.655,
    r: 23.655,
    transform: "translate(8.144 7.876)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_982",
    "data-name": "Ellipse 982",
    cx: 19.897,
    cy: 19.897,
    r: 19.897,
    transform: "translate(11.682 11.855)",
    fill: "#adadad"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_983",
    "data-name": "Ellipse 983",
    cx: 16.138,
    cy: 16.138,
    r: 16.138,
    transform: "translate(15.661 15.392)",
    fill: "#c1c1c1"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "CK_Extra-Logo_Vertical_Positive",
    transform: "translate(1288 4755.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5938",
    "data-name": "Path 5938",
    d: "M26.14,10.03h.9v3.611h-.9V10.03Z",
    transform: "translate(-22.433 -8.561)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5939",
    "data-name": "Path 5939",
    d: "M37.429,12.264a1.089,1.089,0,0,0,.648-1.041c0-.794-.548-1.193-1.532-1.193H35.42v3.611h.9V12.128l.936,1.513H38.32Zm-.855-.379h-.253V10.8h.258c.366,0,.6.165.6.533a.54.54,0,0,1-.61.556Z",
    transform: "translate(-30.397 -8.561)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5940",
    "data-name": "Path 5940",
    d: "M81.984,12.818H83.2v.823H81.07V10.03h.914v2.788Z",
    transform: "translate(-69.571 -8.561)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5941",
    "data-name": "Path 5941",
    d: "M98.11,10.03h2.3v.82h-1.4v.6h1.338v.758H99.011v.611h1.4v.823h-2.3V10.03Z",
    transform: "translate(-84.194 -8.561)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5942",
    "data-name": "Path 5942",
    d: "M128.343,3.2l1.241-1.737h-1.275L127.16,3.129V1.467h-1.115V5.078h1.115V3.416l1.983,2.64a3.186,3.186,0,0,1-4.883-2.785,3.174,3.174,0,1,1,6.344,0,3.375,3.375,0,0,1-.651,2.028l-1.612-2.1h0Z",
    transform: "translate(-106.634)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5943",
    "data-name": "Path 5943",
    d: "M2.168,10.444a1.017,1.017,0,0,0,0,2.029.989.989,0,0,0,.851-.5l.7.469a1.786,1.786,0,0,1-1.566.89,1.869,1.869,0,0,1,0-3.738,1.771,1.771,0,0,1,1.575.884l-.712.482a.956.956,0,0,0-.844-.514",
    transform: "translate(-0.267 -8.186)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5944",
    "data-name": "Path 5944",
    d: "M57.268,10.435a1.017,1.017,0,0,0,0,2.029.989.989,0,0,0,.851-.5l.7.469a1.787,1.787,0,0,1-1.566.89,1.87,1.87,0,0,1,0-3.74,1.773,1.773,0,0,1,1.575.884l-.712.482a.956.956,0,0,0-.844-.514",
    transform: "translate(-47.551 -8.177)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5945",
    "data-name": "Path 5945",
    d: "M113.662,53.907V52.84a2.832,2.832,0,0,0-2.471,1.874V52.957h-.97v6.728h.97V57c0-1.807.919-2.841,2.126-3.046C113.317,53.959,113.453,53.937,113.662,53.907Z",
    transform: "translate(-94.586 -45.103)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5946",
    "data-name": "Path 5946",
    d: "M131.654,53.552a2.839,2.839,0,0,0-2.105-.742h-.989v.965c.311-.032.63-.056.888-.056a1.693,1.693,0,0,1,1.929,1.822v.208a6.611,6.611,0,0,0-1.992-.287c-1.651,0-2.786.756-2.786,2.2v.026a2.21,2.21,0,0,0,2.433,2.1,2.827,2.827,0,0,0,2.345-1.145v1h.959V55.528a2.711,2.711,0,0,0-.681-1.978Zm-.265,3.618a1.968,1.968,0,0,1-2.169,1.808c-.882,0-1.64-.495-1.64-1.341v-.026c0-.807.694-1.353,1.9-1.353a6.5,6.5,0,0,1,1.9.287v.625Z",
    transform: "translate(-108.642 -45.077)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5947",
    "data-name": "Path 5947",
    d: "M3.287,58.8a2.663,2.663,0,0,0,2.056-.95l.606.559a3.321,3.321,0,0,1-2.685,1.262,3.531,3.531,0,0,1-.126-7.028c1.929,0,3.039,1.587,3.039,3.565,0,.091,0,.195-.013.351H.992a2.309,2.309,0,0,0,2.3,2.239Zm1.9-3.046c-.113-1.224-.794-2.265-2.081-2.265A2.288,2.288,0,0,0,.992,55.752Z",
    transform: "translate(-0.01 -44.932)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5948",
    "data-name": "Path 5948",
    d: "M85.061,46.736V39.76h.97v2.031H88.1v.884H86.032v3.93a.979.979,0,0,0,1.1,1.119,1.985,1.985,0,0,0,.946-.234v.86a2.389,2.389,0,0,1-1.173.287,1.685,1.685,0,0,1-1.841-1.9Z",
    transform: "translate(-72.995 -33.938)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5949",
    "data-name": "Path 5949",
    d: "M41.779,56.926,39.321,53.62H40.43l1.929,2.6,1.929-2.6h1.084L42.9,56.9l2.572,3.448H44.351L42.334,57.6,40.3,60.348H39.22l2.559-3.423Z",
    transform: "translate(-33.658 -45.769)",
    fill: "#65676a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5950",
    "data-name": "Path 5950",
    d: "M170.635,10h-.125V9.94h.314V10H170.7v.416h-.064Zm.278-.063h.071l.135.247.135-.247h.07v.479h-.062v-.366l-.138.255h-.007l-.138-.255v.366h-.062V9.94Z",
    transform: "translate(-146.323 -8.485)",
    fill: "#65676a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoyaltyCard);
export default __webpack_public_path__ + "static/media/icon_loyalty_card.bd630a58c671165c7d09f7fa8794712d.svg";
export { ForwardRef as ReactComponent };